export const STATUSES = ["Draft", "In Review", "Ready for Signature", "Pending Signature", "Signed",
  "Active", "Completed", "Expired", "Cancelled", "Archived"];

export const STATUS_STYLE = {
  Draft: "bg-white/8 text-[#A1A1AA]",
  "In Review": "bg-blue-500/15 text-blue-300",
  "Ready for Signature": "bg-amber-500/15 text-amber-300",
  "Pending Signature": "bg-orange-500/15 text-orange-300",
  Signed: "bg-[#D4AF37]/15 text-[#D4AF37]",
  Active: "bg-emerald-500/15 text-emerald-300",
  Completed: "bg-teal-500/15 text-teal-300",
  Expired: "bg-red-500/15 text-red-300",
  Cancelled: "bg-zinc-600/20 text-zinc-400",
  Archived: "bg-zinc-500/15 text-zinc-300",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = iso.length <= 10 ? new Date(iso + "T00:00:00") : new Date(iso);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch { return "—"; }
}
